import { useEffect, useState } from 'react'
import {
  isStandardDictionaryLoaded,
  loadStandardDictionaryLexicon,
} from '~/boggle/engine/standard/lexicon'

/**
 * Tracks dictionary readiness. Loading starts from the app root on first paint; this hook
 * subscribes to the same `loadStandardDictionaryLexicon()` promise. When
 * `bypassDictionaryWait` is true (dev “free dictionary”), returns ready immediately.
 */
export function useDeferredStandardDictionary(bypassDictionaryWait: boolean): boolean {
  const [ready, setReady] = useState(
    () => bypassDictionaryWait || isStandardDictionaryLoaded(),
  )

  useEffect(() => {
    if (bypassDictionaryWait || isStandardDictionaryLoaded()) {
      setReady(true)
      return
    }

    let cancelled = false

    void loadStandardDictionaryLexicon()
      .then(() => {
        if (!cancelled) {
          setReady(true)
        }
      })
      .catch(error => {
        console.error(error)
      })

    return () => {
      cancelled = true
    }
  }, [bypassDictionaryWait])

  return ready
}
